import {EmailDto, SmsOptInSubscribeDto} from 'puffco-api-axios-client';

import {marketOptInApi} from './apis';

const subscribeToEmail = async (emailDto: EmailDto) => {
  return marketOptInApi.subscribeEmail({emailDto});
};

const subscribeToSms = async (smsOptInSubscribeDto: SmsOptInSubscribeDto) => {
  return marketOptInApi.subscribeSms({smsOptInSubscribeDto});
};

export const marketOptInAccess = {
  subscribeToSms,
  subscribeToEmail,
};
